/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/assets/js/app.js":
/*!******************************!*\
  !*** ./src/assets/js/app.js ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports) {

jQuery.fn.cleardefault = function () {
  return this.focus(function () {
    if (this.value == this.defaultValue) {
      this.value = "";
      jQuery(this).addClass('selected-input');
    }
  }).blur(function () {
    if (!this.value.length) {
      this.value = this.defaultValue;
      jQuery(this).removeClass('selected-input');
    }
  });
};

jQuery(document).ready(function () {
    jQuery('#universal_video_background_default').universal_video_background({
        width: 1920,
        height: 1200,
        autoPlayFirstVideo:true,
        width100Proc:true,
        height100Proc:true,
        responsive:true,
        setAsBg:true,
        responsiveRelativeToBrowser:false,
        initialVolume: 0,
        autoHideBottomNav:true,
        showVideoControls:false,
        showBottomNav:false,
        showOnInitBottomNav:false,
        bottomNavPos:'right', //left/center/right
        bottomNavLateralMargin:3,
        borderWidth: 0,
        borderColor: '#FFFFFF',
        texturePath:'skins/patternFullScreenBg_1.png',
        thumbsBorderColorON:'#FF0000',
        thumbsBorderColorOFF:'#000000',
        thumbsWrapperBg:'transparent', //hexa or image
        thumbsBgOffImgOpacity:30,
        thumbsWrapperMarginTop:40
     
    });
    
  jQuery(".ginput_container input, .ginput_container textarea").cleardefault();
  jQuery('.js-menu-trgr').click(function () {
    var $handler = jQuery(this);
    jQuery(this).toggleClass("opend");
    jQuery('.s-main-menu').slideToggle();

    if (!$handler.hasClass('opend')) {
      jQuery('#dropdowns').slideUp(400);
    }
  });
  jQuery('.c-dropdowns, .s-main-menu li[data-dropdown]').on('mouseover', function (e) {
    e.stopPropagation();
  });
  jQuery('body').on('mouseover', function () {
    // jQuery('#dropdowns').slideUp();
    jQuery('#dropdowns').hide();
  });

  jQuery('.js-product-single-image-slider').slick({
    autoplay: false,
    prevArrow: jQuery('#featured-product-image-prev'),
    nextArrow: jQuery('#featured-product-image-next'),
    dots: false,
    autoplaySpeed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: false,
    infinite: !0,
    pauseOnDotsHover: !1,
    pauseOnFocus: !1,
    pauseOnHover: !1,
    touchMove: !0,
  });
  jQuery('.js-featured-product').slick({
    autoplay: false,
    prevArrow: jQuery('#featured-product-prev'),
    nextArrow: jQuery('#featured-product-next'),
    dots: true,
    autoplaySpeed: 4000,
    slidesToShow: 6,
    slidesToScroll: 1,
    adaptiveHeight: false,
    appendDots: jQuery('.s-featured-product-controller'),
    infinite: !0,
    pauseOnDotsHover: !1,
    pauseOnFocus: !1,
    pauseOnHover: !1,
    touchMove: !0,
    responsive: [
        {
        
            breakpoint: 1650,
            settings: {
              slidesToShow: 5
            }
          }, {
        
      breakpoint: 1024,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        dots: false
      }
    }]
  });
  jQuery('.js-testimonial-product-slider').slick({
    autoplay: false,
    prevArrow: jQuery('#testimonial-product-prev'),
    nextArrow: jQuery('#testimonial-product-next'),
    dots: true,
    speed: 1200,
    useCSS: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: false,
    appendDots: jQuery('.s-testimonial-product-controller'),
    infinite: !0,
    pauseOnDotsHover: !1,
    pauseOnFocus: !1,
    pauseOnHover: !1,
    touchMove: !0
  });
  jQuery('.c-hero-slider').slick({
//     autoplay: true,
    autoplay: true,
    arrows: false,
    dots: true,
    speed: 1200,
    useCSS: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: false,
    appendDots: jQuery('.hero-slider-dots-controller'),
    infinite: !0,
    pauseOnDotsHover: !1,
    pauseOnFocus: !1,
    pauseOnHover: !1,
    touchMove: !0,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          adaptiveHeight: true,
        }
      }
    ]
  });
});
/**
 * Header menu dropdown management
 */

function manageProductThumbnails(){
    var $thumbWrapper = jQuery('.product-single-thumbnails-wrap');
    var $thumbList = $thumbWrapper.find('.grid');
    var $productThumb = $thumbWrapper.find('li.grid__item');
    var productThumbHeight = $productThumb.height();
    var maxThumb = 5;
    var wrapperHeight = productThumbHeight * maxThumb;
    var totalThumbAvailable = $thumbWrapper.find('li.grid__item').length;
    var currentIndex = maxThumb;
    var $buttonArrow = jQuery('.pe-custom-thumb-slider-arrow');
    var currentTranslateValue = 0;
    var difference = 0;
    var heightToAnimate = 0;

    //$thumbWrapper.css('height', wrapperHeight);
    $thumbWrapper.css('overflow', 'hidden');

    $buttonArrow.click(function(e){
        if(jQuery(this).hasClass('arrow-type-down')){
            if(currentIndex != totalThumbAvailable){
                currentIndex = currentIndex + 1;
                heightToAnimate = currentIndex - maxThumb;
                heightToAnimate = heightToAnimate * productThumbHeight;
                $thumbList.css('transform','translateY(-'+heightToAnimate+'px)'); 
                $thumbWrapper.find('li.grid__item:nth-of-type('+currentIndex+')').fadeIn();
                $thumbWrapper.find('li.grid__item:nth-of-type('+currentIndex+') a').click();
            }
    
            if(currentIndex == totalThumbAvailable){
                //jQuery('.pe-custom-thumb-slider-arrow.arrow-type-down').hide();
                //jQuery('.pe-custom-thumb-slider-arrow.arrow-type-up').show();
            }
        }else{
            if(currentIndex != maxThumb){
                difference = currentIndex - maxThumb - 1;
                heightToAnimate = heightToAnimate - productThumbHeight;

                $thumbList.css('transform','translateY(-'+heightToAnimate+'px)'); 
                currentIndex = currentIndex - 1;
                $thumbWrapper.find('li.grid__item:nth-of-type('+currentIndex+') a').click();
            }

            if(currentIndex == maxThumb){
                //jQuery('.pe-custom-thumb-slider-arrow.arrow-type-up').hide();
                //jQuery('.pe-custom-thumb-slider-arrow.arrow-type-down').show();
            }
        }
    });

    function selectContentByVariantID(variationId){
        if(!variationId) return;

        var $singleOffer = jQuery('.c-single-product__offer'),
            $singleBanner = jQuery('.o-panel--product-single-banner'),
            $singleTestimonial = jQuery('.o-panel--testimonial-product'),
            $singleFeatures = jQuery('.o-panel--product-features'),
            $singleSpecifications = jQuery('.product-specifications'),
            $singleFeaturedProducts = jQuery('.o-panel--featured-product'),
            $singleOfferTarget = jQuery('.c-single-product__offer[data-pe-varient="'+variationId+'"]'),
            $singleBannerTarget = jQuery('.o-panel--product-single-banner[data-pe-varient="'+variationId+'"]'),
            $singleTestimonialTarget = jQuery('.o-panel--testimonial-product[data-pe-varient="'+variationId+'"]'),
            $singleFeaturesTarget = jQuery('.o-panel--product-features[data-pe-varient="'+variationId+'"]'),
            $singleSpecificationsTarget = jQuery('.product-specifications[data-pe-varient="'+variationId+'"]'),
            $singleFeaturedProductsTarget = jQuery('.o-panel--featured-product[data-pe-varient="'+variationId+'"]');

        if($singleOfferTarget.length){
            $singleOffer.hide();
            $singleOfferTarget.show();
        }

        if($singleBannerTarget.length){
            $singleBanner.hide();
            $singleBannerTarget.show();
        }

        if($singleTestimonialTarget.length){
            $singleTestimonial.hide();
            $singleTestimonialTarget.show();
        }

        if($singleFeaturesTarget.length){
            $singleFeatures.hide();
            $singleFeaturesTarget.show();
        }

        if($singleSpecificationsTarget.length){
            $singleSpecifications.hide();
            $singleSpecificationsTarget.show();
        }

        if($singleFeaturedProductsTarget.length){
            $singleFeaturedProducts.hide();
            $singleFeaturedProductsTarget.show();
        }
    }

    jQuery('.c-single-product').on('click', '.collection-color-swatch li', function(){
        var $handler = jQuery(this);
        
        if(jQuery(window).width() > 767){
            setTimeout(function(){
                var variationId = $handler.attr('variant_id');
                var selectedDataThumbId = jQuery('.product-single__thumbnails-item').find('.active-thumb').data('thumbnail-id');
                var itemPositionIndex = jQuery('.product-single__thumbnails-item[data-list-thumbnail-id="'+selectedDataThumbId+'"]').index()+1;
                
                selectContentByVariantID(variationId);

                if(itemPositionIndex < currentIndex - 4 || itemPositionIndex > currentIndex){
                    var targetIndex = itemPositionIndex - 1;
                    if(targetIndex < 0){
                        targetIndex = 0;
                    }

                    var heightToAnimateSwatch = targetIndex * productThumbHeight;

                    $thumbList.css('transform','translateY(-'+heightToAnimateSwatch+'px)'); 
                    $thumbWrapper.find('li.grid__item').fadeIn();
                    currentIndex = targetIndex + maxThumb;

                    if(currentIndex == totalThumbAvailable){
                        jQuery('.pe-custom-thumb-slider-arrow.arrow-type-down').hide();
                        jQuery('.pe-custom-thumb-slider-arrow.arrow-type-up').show();
                    }else{
                        jQuery('.pe-custom-thumb-slider-arrow.arrow-type-up').hide();
                        jQuery('.pe-custom-thumb-slider-arrow.arrow-type-down').show();
                    }
                }

                selectedDataThumbId = 8;
                itemPositionIndex = 9
                if(9 < 7 - 4 || itemPositionIndex > currentIndex){

                }

            }, 400);
        }else{
            setTimeout(function(){
                var variationId = $handler.attr('variant_id');
                var selectedDataThumbId = jQuery('.product-single__thumbnails-item').find('.active-thumb').data('thumbnail-id');
                var itemPositionIndex = jQuery('.product-single__thumbnails-item[data-list-thumbnail-id="'+selectedDataThumbId+'"]').index();

                setTimeout(function(){
                    $handler.find('.tooltip_open').hide();
                }, 2000);
                
                selectContentByVariantID(variationId);

                jQuery('.js-product-single-image-slider').slick('slickGoTo', itemPositionIndex);
            }, 400);
        }
    });

    //console.log(productThumbHeight, maxThumb, wrapperHeight, totalThumbAvailable);
}

jQuery(window).load(function(){
    manageProductThumbnails();
});

(function () {
    jQuery('.js-desktop-search').click(function($){
        jQuery('.c-header__cart').toggleClass('active');
    });

    jQuery('.js-mobile-search-button, .c-mobile-search-form__icon-close').click(function($){
        jQuery('.c-mobile-search-form').fadeToggle();
    });

  var $dropdownWrap = jQuery('#dropdowns'),
      $dropdownItems = jQuery('.c-dropdowns__item');
  jQuery('.s-main-menu li[data-dropdown]').hover(function () {
    var $handler = jQuery(this),
        dropdown = $handler.data('dropdown'),
        $targetDropdown = jQuery('.c-dropdown-' + dropdown);
    $dropdownItems.hide();
    $targetDropdown.show();
    // $dropdownWrap.filter(':not(:animated)').slideDown(400);
    $dropdownWrap.show();
  });

  jQuery('.s-main-menu li[data-dropdown]').click(function(){
    var $handler = jQuery(this),
        dropdown = $handler.data('dropdown'),
        $targetDropdown = jQuery('.c-dropdown-' + dropdown);
    if(jQuery(window).width() < 768){
        if($targetDropdown.length){
            return false;
        }
    }
  });

})();

/***/ }),

/***/ 0:
/*!************************************!*\
  !*** multi ./src/assets/js/app.js ***!
  \************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /Users/hello/Sites/shopify/mytest/src/assets/js/app.js */"./src/assets/js/app.js");


/***/ })

/******/ });
//
// HC - fixing slider aspect ratio - 1 Dec '22
function resizeSliders(){
  if($(".slick-dots").length>1){
      $(".slick-dots")[0].remove()
  }
  if(window.innerWidth > 767){
    $('#hero .slick-track .c-hero-slider-item').each((index, item)=>{
      let imageSrc = $(item).css("background-image").replace(/url\((['"])?(.*?)\1\)/gi, '$2').split(',')[0];
      let image = new Image();
      image.src = imageSrc;
  
      image.onload = function () {
        let width = image.width,
          height = image.height;
          $(item).css("height",height/(width/window.innerWidth))
          $(item).css("width","100vw")
          $(item).closest(".o-panel--hero").css("height",height/(width/window.innerWidth))
        $(item).closest(".o-panel--hero").css("width","100vw")
      };
  })
  }else{
    $('#hero .slick-track .c-hero-slider-item').each((index, item)=>{
        let imageSrc = $(item).css("background-image").replace(/url\((['"])?(.*?)\1\)/gi, '$2').split(',')[0];
        let image = new Image();
        image.src = imageSrc;
    
        image.onload = function () {
            $(item).closest(".o-panel--hero").css("height","auto")
          $(item).closest(".o-panel--hero").css("width","100vw")
        };
    })
  }
}

// HC - fixing slider aspect ratio - 1 Dec '22
$(document).ready(function(){
 if($(".slick-dots").length>0){
      $(".slick-dots")[0].remove()
    } 
  resizeSliders();
  var globalResizeTimer = null;

  $(window).resize(function() {
    resizeSliders();
  });
});
//# sourceMappingURL=app.js.map

/* HC - Product page adjustments - 28 Sep '23 */
$('.hc-slider').slick({
  dots: false,
  infinite: true,
  arrows: false,
  fade: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  asNavFor: '.hc-slider-vertical',
  responsive: [
      {
        breakpoint: 480,
        settings: {
            arrows: true,
            prevArrow: '<div class="hc-arrow-right"><i class="fa fa-angle-right" aria-hidden="true"></i></div>',
            nextArrow: '<div class="hc-arrow-left"><i class="fa fa-angle-left" aria-hidden="true"></i></div>',
        }
      }
    ]
});

$('.hc-slider-vertical').slick({
  dots: false,
  infinite: true,
  arrows: true,
  vertical: true,
  verticalSwiping: true,
  prevArrow: '<div class="hc-arrow-up"><i class="fa fa-angle-up" aria-hidden="true"></i></div>',
  nextArrow: '<div class="hc-arrow-down"><i class="fa fa-angle-down" aria-hidden="true"></i></div>',
  slidesToShow: 4,
  slidesToScroll: 1,
  asNavFor: '.hc-slider',
  focusOnSelect: true,
  responsive: [
      {
        breakpoint: 480,
        settings: {
          vertical: false,
          verticalSwiping: false,
          arrows: false
        }
      }
    ]
}); 

$('.product-single-image-slider-mobile__inner-wrap').on('afterChange', function(event, slick, currentSlide, nextSlide) {   
  $('.product-single__thumbnail').removeClass('active-thumb');
  $('.product-single__thumbnails-item[data-slick-index="'+currentSlide+'"] a').addClass('active-thumb');
});

$(document).on('click', '.hc-button', function() {
  $(this).parent().toggleClass('hc-active');
});

$(document).ready(function() {
  var height = 75;
  if(window.innerWidth <= 480) {
    height = 65;
  }
  if(window.innerWidth <= 480) {
    height = 65;
  }
  $('.max-height.show').css('max-height', height);
});

$('#show-more').on('click', function(e) {
  e.preventDefault();
  $('.max-height.show').css('max-height', 'unset');
  $('#show-less').css('display','block');
  $(".max-height").removeClass('show');
  $(this).css('display','none');
});

$('#show-less').click(function(){
  var height = 75;
  if(window.innerWidth <= 480) {
    height = 65;
  }
  $(".max-height").addClass('show');
  $('.max-height.show').css('max-height', height);
  $(this).css('display','none');
  $('#show-more').css('display','block');
});

$(window).on('resize orientationchange', function() {
  var height = 75;
  if(window.innerWidth <= 480) {
    height = 65;
  }
  $('.max-height.show').css('max-height', height);
});

$(document).ready(function() {
  if($('.selector-wrapper').length){
    var hc_value = $('.single-option-selector').val();
    $('.hc-product-single__thumbnails-item[data-variant="'+hc_value+'"]').trigger('click');
  }
});

$(document).on('click', '.csp-swatch-label', function() {
  var hc_value = $(this).attr('data-value');
  $('.hc-product-single__thumbnails-item[data-variant="'+hc_value+'"]').trigger('click');
});


